// Styles for PhotoEssay go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled, { createGlobalStyle } from 'styled-components';

/** Tablet vertical modal is portaled under `body`; scope layout tweaks globally by class. */
export const PhotoEssayVerticalTabletModalGlobalStyle = createGlobalStyle`
  /* Off-screen host: VideoMolecule must mount in DOM so we can click .video-image-play-btn; modal still portals to body. */
  .photo-essay-vertical-tablet-modal-host {
    position: fixed;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
    pointer-events: none;
  }
`;

export const StyledPhotoEssay = styled.div`
  /* Scope to .video-cinemograph-container only - VideoMolecule modal is portaled to body,
     so these must NOT apply to modal's video-js (which would hide fullscreen via overflow) */
  .video-cinemograph-container video-js,
  .photo-essay-image,
  .video-cinemograph-loader,
  .photo-essay-video-molecule-wrapper .video-image-container {
    width: 100%;
    height: auto !important;
    padding-top: 0 !important;
  }

  /* Variation 1 + VideoMolecule: ensure picture/img take full width of container */
  .photo-essay-video-molecule-wrapper .video-image-container picture,
  .photo-essay-video-molecule-wrapper .video-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .video-cinemograph-container {
    position: relative;
    width: 100%;

    /* Hide specific controls - scoped to container only (like OneUpHighlight, no global vjs hides) */
    .vjs-title-bar,
    .vjs-big-play-button,
    .vjs-quality-menu-wrapper {
      display: none !important;
    }

    /* Hide Brightcove controls for cinemograph */
    &--cinemograph .vjs-control-bar {
      display: none !important;
    }

    /* Custom poster overlay with renditions for video - hide Brightcove poster */
    &--custom-poster .vjs-poster {
      display: none !important;
    }

    .photo-essay-video-poster-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      pointer-events: none;

      &--hidden {
        display: none !important;
      }

      .photo-essay-video-poster-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      picture,
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    /* White Brightcove/Video.js controls - matches mi-ui-library Video component */
    [class^='vjs-']::before {
      font-family: 'VideoJS';
    }
    .video-js {
      width: 100% !important;
      overflow: hidden;
      [class*='icon-']::before {
        font-family: 'VideoJS';
        color: ${baseVariables.color.base20};
      }
      .vjs-control-bar {
        width: 100% !important;
        left: 0;
        right: 0;
        position: absolute !important;
        color: ${baseVariables.color.base20};
        .vjs-control {
          width: 2.5em;
        }
      }
      .vjs-progress-control {
        height: ${toRem(4.19)};
        top: 0;
        .vjs-play-progress {
          background: ${baseVariables.color.base20};
        }
      }
      .vjs-volume-level {
        background: ${baseVariables.color.base20};
      }
      .vjs-menu .vjs-menu-item.vjs-selected {
        background: ${baseVariables.color.base20};
        .vjs-menu-item-text {
          color: ${baseVariables.color.base10};
        }
      }
    }
  }
  .icon-play-pause_video {
    position: absolute;
    z-index: 2;
    height: ${toRem(70)};
    width: ${toRem(70)};
    @media only ${baseVariables.mediaQuery.lg} {
      height: ${toRem(112)};
      width: ${toRem(112)};
    }
    pointer-events: auto;
    border: ${toRem(1)} solid ${baseVariables.color.base20};
    background: ${baseVariables.color.base10};
    opacity: 62%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    ponter-events: auto;
    .play-pause-btn {
      color: ${baseVariables.color.base20};
      transform: rotate(-45deg);
    }
  }
  /* Hide VideoMolecule default play button when using custom play button */
  .photo-essay-video-molecule-wrapper .video-image-play-btn {
    display: none !important;
  }

  .icon-play-pause_cinemograph {
    height: ${toRem(24)};
    width: ${toRem(24)};
    position: absolute;
    right: ${toRem(8)};
    bottom: ${toRem(8)};
    background: ${baseVariables.color.base10};
    opacity: 62%;
    border-radius: 50%;
    .icon-xs {
      color: ${baseVariables.color.base20};
    }
  }
  .variation_one {
    video-js,
    .photo-essay-image,
    .video-cinemograph-loader,
    .photo-essay-video-molecule-wrapper .video-image-container,
    .video-cinemograph-container--custom-poster {
      aspect-ratio: 1/1;
    }
  }

  .variation_two .asset-one-container,
  .variation_three .asset-two-container {
    video-js,
    .photo-essay-image,
    .video-cinemograph-loader,
    .video-cinemograph-container--custom-poster {
      aspect-ratio: 16/9;
    }
  }

  .variation_three .asset-one-container,
  .variation_two .asset-two-container {
    video-js,
    .photo-essay-image,
    .video-cinemograph-loader,
    .video-cinemograph-container--custom-poster {
      aspect-ratio: 9/16;
    }
  }
`;
